// ============================================================
// CONTRACT ADDRESSES per chain
// ------------------------------------------------------------
// Replace the placeholder addresses with your deployed contracts.
// ============================================================

import { ACTIVE_NETWORK } from './network';

export const CONTRACT_ADDRESSES = {
  mainnet: {
    planLogic:   '0x0000000000000000000000000000000000000000',
    planAdmin:   '0x0000000000000000000000000000000000000000',
    planRewards: '0x0000000000000000000000000000000000000000',
    storage:     '0x0000000000000000000000000000000000000000',
    planViews:   '0x0000000000000000000000000000000000000000',
    grx:         '0x0000000000000000000000000000000000000000',
    usdt:        '0x55d398326f99059fF775485246999027B3197955',
    grxUsdtPair: '0x0000000000000000000000000000000000000000',
    pinkSaleLocker:'0x407993575c91ce7643a4d4cCACc9A98c36eE1BBE',
    pancakeRouter: '0x10ED43C718714eb63d5aA57B78B54704E256024E',
  },
  testnet: {
    planLogic:   '0xC6583Fd8D4DE90e1D0f8518dFEF343641C16Ee7d',
    planAdmin:   '0x3598cCC5A8C0f512DCFB5da609A56B967e118c32',
    planRewards: '0x876aA44f5B95e55fA0Eb69e749AbAdc41F534A07', // ← UPDATE after deploying GRXPlanRewards
    storage:     '0xc769D9E4B2356c3d116d5E92cbDD35f950fEfe70',
    planViews:   '0xE471C5E8E8b7461DF0F0435636d0a15B39397Ec1',
    grx:         '0xcc92f10CD077cB9cf402eebC152Cf685B879F56e',
    usdt:        '0x2620D043772DdE2a4B5cfBB807Aa3ebd678DD1DC',
    grxUsdtPair: '0xaE1EdFadcf9F6DB2B3AF84d4e307b4130dd13B39',
    pinkSaleLocker:'0x5E5b9bE5fd939c578ABE5800a90C566eeEbA44a5',
    pancakeRouter: '0xD99D1c33F9fC3444f8101754aBC46c52416550D1',
  },
};

export const ADDRESSES = CONTRACT_ADDRESSES[ACTIVE_NETWORK];
